import {HybirdBridge, invoke} from "@hybird/core/bridge/hybirdBridge";
import {BridgeMethod} from "@hybird/core/bridge/core";

export class FlutterPreview extends BridgeMethod {
  constructor() {
    super();
  }

  /**
   * 预览网络pdf
   *
   * @param  url pdf网络地址，必填
   * @param fileName pdf文件名称，选填
   */
  pdfPreviewByUrl(url, fileName) {
    return invoke("pdfPreviewByUrl", {
              params: {
                url, fileName,
              }
            },
    );
  }

  /**
   * 预览本地pdf
   *
   * @param url pdf本地地址，必填
   * @param fileName pdf文件名称，选填
   */
  pdfPreviewByPath(url, fileName) {
    return invoke("pdfPreviewByPath", {
              params: {
                'url': url,
                'fileName': fileName,
              }
            },
    );
  }

  /**
   * 保存网络图片到本地
   *
   * @param url
   * - url: 所要保存图片的地址，必填
   */
  saveNetworkImage(url) {
    return invoke("saveNetworkImage", {
              params: {
                url
              }
            },
    );
  }

  /**
   * 手机打开文件
   * 需要 Permission.manageExternalStorage
   * @param url  所要打开文件的地址，必填
   * @param filename 文件名字
   */
  openFile(url, filename) {
    return invoke("openFile", {
              params: {
                url, filename
              }
            },
    );
  }

}